<template>
  <div class="veterinary">
    <div class="veterinary-box">
      <van-tabs v-model="active" sticky @change="tabs">

        <van-tab title="课程介绍">
          <div class="overview-box">
            <div class="overview-img">
              <img src="../assets/veterinarypropagateimg/1@2x.png">
            </div>
            <div class="overview-img">
              <img src="../assets/veterinarypropagateimg/2@2x.png">
            </div>
            <div class="overview-img">
              <img src="../assets/veterinarypropagateimg/3@2x.png">
            </div>
            <div class="overview-img">
              <img src="../assets/veterinarypropagateimg/4@2x.png">
            </div>
            <div class="overview-img">
              <img src="../assets/veterinarypropagateimg/5@2x.png">
            </div>
            <div class="overview-img">
              <img src="../assets/veterinarypropagateimg/6@2x.png">
            </div>
          </div>
        </van-tab>

        <van-tab title="免费试听">
          <div class="video-list">
            <div class="video-title">往期课程</div>
            <div class="video-box">
              <div class="video-content">
                <vue-aliplayer-v2 ref="VueAliplayerV21" :options="options1"  @play="handleReady1" />
              </div>
              <div class="video-text">通关班兽医微生物学第一讲</div>
            </div>
            <div class="video-box">
              <div class="video-content">
                <vue-aliplayer-v2 ref="VueAliplayerV22" :options="options2"  @play="handleReady2" />
              </div>
              <div class="video-text">通关班猪病第一讲</div>
            </div>
            <div class="video-box">
              <div class="video-content">
                <vue-aliplayer-v2 ref="VueAliplayerV23" :options="options3"  @play="handleReady3" />
              </div>
              <div class="video-text">通关班宠物综合第一讲</div>
            </div>
            <div class="video-title video-heigh">知识点</div>
            <div class="video-box">
              <div class="video-content">
                <vue-aliplayer-v2 ref="VueAliplayerV24" :options="options4"  @play="handleReady4" />
              </div>
              <div class="video-text">细菌的形态</div>
            </div>
            <div class="video-box">
              <div class="video-content">
                <vue-aliplayer-v2 ref="VueAliplayerV25" :options="options5"  @play="handleReady5" />
              </div>
              <div class="video-text">麻黄汤</div>
            </div>
            <div class="video-box">
              <div class="video-content">
                <vue-aliplayer-v2 ref="VueAliplayerV26" :options="options6"  @play="handleReady6" />
              </div>
              <div class="video-text">问诊</div>
            </div>
          </div>
        </van-tab>

      </van-tabs>
    </div>

  </div>
</template>

<script>
import VueAliplayerV2 from 'vue-aliplayer-v2';
import { wxshare } from '@/utils/utils.js'
import { getVideoIncr } from '@/api/resetApi.js'

export default {
  name: 'veterinary',
  components: {
    VueAliplayerV2: VueAliplayerV2.Player
  },
  data(){
    return{
      active: 0,
      playerv1: 0,
      playerv2: 0,
      playerv3: 0,
      playerv4: 0,
      playerv5: 0,
      playerv6: 0,
      options1: {
        width: "100%",
        height: "200px",
        source: 'http://video2.sslab.com.cn/5f1189ce6c9943e29c06285b8341a089/3bc59de334c54328ae43a0bba4d79779-d08713de34f51ff38604e0b41e665da4-ld.mp4',
        cover: 'http://zkjy-plk-saas-dev.oss-cn-beijing.aliyuncs.com/2021/03/08/1615170282876.png?Expires=4770843883&OSSAccessKeyId=LTAI4Fkbt3Lke1S5PNNArS1r&Signature=vKMAn6HVdwBZcopWcfaeBbEYRGI%3D',
        autoplay: false,
        isLive: false,
        rePlay: true,
        playsinline: true,
        preload: true,
        useH5Prism: true,
        disableSeek: true,
        controlBarVisibility: 'click',
        showBarTime: 3000,
        
        skinLayout: [
          {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
          // {name:"liveDisplay", align:"tlabs", x: 0, y:0},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay", align: "cc"},
          {name:"tooltip", align:"blabs",x: 0, y: 56},
          {name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              // {name:"liveDisplay", align:"tlabs", x: 15, y:6},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name:"fullScreenButton", align:"tr", x:10, y: 10},
              {name: "progress", align: "blabs", x: 0, y: 44},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name:"volume", align:"tr", x:5, y:10}
            ]
          }
        ]
      },
      options2: {
        width: "100%",
        height: "200px",
        source: 'http://video2.sslab.com.cn/4c2fee3c8cc246be9fdf579093f4377c/181035b755354f919fda2fbf8f95c854-d9db0082bc74faac47695576a137521c-ld.mp4',
        cover: 'http://zkjy-plk-saas-dev.oss-cn-beijing.aliyuncs.com/2021/03/08/1615170484466.png?Expires=4770844085&OSSAccessKeyId=LTAI4Fkbt3Lke1S5PNNArS1r&Signature=cwymePLYh0Dwbl5Z0mP6qd2Nf6o%3D',
        autoplay: false,
        isLive: false,
        rePlay: true,
        playsinline: true,
        preload: true,
        useH5Prism: true,
        disableSeek: true,
        controlBarVisibility: 'click',
        showBarTime: 3000,
        
        skinLayout: [
          {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
          // {name:"liveDisplay", align:"tlabs", x: 0, y:0},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay", align: "cc"},
          {name:"tooltip", align:"blabs",x: 0, y: 56},
          {name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              // {name:"liveDisplay", align:"tlabs", x: 15, y:6},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name:"fullScreenButton", align:"tr", x:10, y: 10},
              {name: "progress", align: "blabs", x: 0, y: 44},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name:"volume", align:"tr", x:5, y:10}
            ]
          }
        ]
      },
      options3: {
        width: "100%",
        height: "200px",
        source: 'http://video2.sslab.com.cn/8aa277ef54a8439fa9333fc786f2486f/f44794a9e4724900ae47fd39b500fb51-e86ed74c1dff3aa970180ae2f6d1a83f-ld.mp4',
        cover: 'http://zkjy-plk-saas-dev.oss-cn-beijing.aliyuncs.com/2021/03/08/1615170512776.png?Expires=4770844112&OSSAccessKeyId=LTAI4Fkbt3Lke1S5PNNArS1r&Signature=mRbHncf8sDN%2BTuyZr8Unw936Zpw%3D',
        autoplay: false,
        isLive: false,
        rePlay: true,
        playsinline: true,
        preload: true,
        useH5Prism: true,
        disableSeek: true,
        controlBarVisibility: 'click',
        showBarTime: 3000,
        
        skinLayout: [
          {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
          // {name:"liveDisplay", align:"tlabs", x: 0, y:0},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay", align: "cc"},
          {name:"tooltip", align:"blabs",x: 0, y: 56},
          {name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              // {name:"liveDisplay", align:"tlabs", x: 15, y:6},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name:"fullScreenButton", align:"tr", x:10, y: 10},
              {name: "progress", align: "blabs", x: 0, y: 44},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name:"volume", align:"tr", x:5, y:10}
            ]
          }
        ]
      },
      options4: {
        width: "100%",
        height: "200px",
        source: 'http://video2.sslab.com.cn/803ffefbe1ba43ba8ae9b9251ae08c80/f3b98ba78b794be09be6f8fdda946441-ee6f5e194dacd532441d1114b0f515f5-ld.mp4',
        cover: 'http://zkjy-plk-saas-dev.oss-cn-beijing.aliyuncs.com/2021/03/08/1615170533963.png?Expires=4770844135&OSSAccessKeyId=LTAI4Fkbt3Lke1S5PNNArS1r&Signature=DtTkSQA6mBH%2B64SDDMWIUbC9L4k%3D',
        autoplay: false,
        isLive: false,
        rePlay: true,
        playsinline: true,
        preload: true,
        useH5Prism: true,
        disableSeek: true,
        controlBarVisibility: 'click',
        showBarTime: 3000,
        
        skinLayout: [
          {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
          // {name:"liveDisplay", align:"tlabs", x: 0, y:0},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay", align: "cc"},
          {name:"tooltip", align:"blabs",x: 0, y: 56},
          {name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              // {name:"liveDisplay", align:"tlabs", x: 15, y:6},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name:"fullScreenButton", align:"tr", x:10, y: 10},
              {name: "progress", align: "blabs", x: 0, y: 44},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name:"volume", align:"tr", x:5, y:10}
            ]
          }
        ]
      },
      options5: {
        width: "100%",
        height: "200px",
        source: 'http://video2.sslab.com.cn/01627240185d4175a4bd03299bada01e/36ed898aaa804b7080b57c4708e9c451-507caa8c2c20ad3788a3843261cccbd1-ld.mp4',
        cover: 'http://zkjy-plk-saas-dev.oss-cn-beijing.aliyuncs.com/2021/03/08/1615170554388.png?Expires=4770844154&OSSAccessKeyId=LTAI4Fkbt3Lke1S5PNNArS1r&Signature=wTvvEDrTsSC6ltv4vBSKn7YZmEM%3D',
        autoplay: false,
        isLive: false,
        rePlay: true,
        playsinline: true,
        preload: true,
        useH5Prism: true,
        disableSeek: true,
        controlBarVisibility: 'click',
        showBarTime: 3000,
        
        skinLayout: [
          {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
          // {name:"liveDisplay", align:"tlabs", x: 0, y:0},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay", align: "cc"},
          {name:"tooltip", align:"blabs",x: 0, y: 56},
          {name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              // {name:"liveDisplay", align:"tlabs", x: 15, y:6},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name:"fullScreenButton", align:"tr", x:10, y: 10},
              {name: "progress", align: "blabs", x: 0, y: 44},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name:"volume", align:"tr", x:5, y:10}
            ]
          }
        ]
      },
      options6: {
        width: "100%",
        height: "200px",
        source: 'http://video2.sslab.com.cn/212a29115288497d84e6ed04255dd441/c1fa8157c0274383a12e86b37e8bbdb8-bfe0db9c189d748a6993d90a40d73e86-ld.mp4',
        cover: 'http://zkjy-plk-saas-dev.oss-cn-beijing.aliyuncs.com/2021/03/08/1615170572734.png?Expires=4770844173&OSSAccessKeyId=LTAI4Fkbt3Lke1S5PNNArS1r&Signature=z8z2ZGYbgCrGgyPmer1sna72DoM%3D',
        autoplay: false,
        isLive: false,
        rePlay: true,
        playsinline: true,
        preload: true,
        useH5Prism: true,
        disableSeek: true,
        controlBarVisibility: 'click',
        showBarTime: 3000,
        
        skinLayout: [
          {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
          // {name:"liveDisplay", align:"tlabs", x: 0, y:0},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay", align: "cc"},
          {name:"tooltip", align:"blabs",x: 0, y: 56},
          {name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              // {name:"liveDisplay", align:"tlabs", x: 15, y:6},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name:"fullScreenButton", align:"tr", x:10, y: 10},
              {name: "progress", align: "blabs", x: 0, y: 44},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name:"volume", align:"tr", x:5, y:10}
            ]
          }
        ]
      },
      title: '2021执业兽医师资格考试',
      desc: '4月2号开课，现在可预约报名啦~ ',
      img: 'https://zkjy.oss-cn-beijing.aliyuncs.com/2021/c307aac117f082538e6528d8b3908c9.jpg',
    }
  },
  created(){
    this.id = this.$route.query.id
    wxshare(this.img,this.title,this.desc)
  },
  methods: {
    tabs(){
      if (this.active!==1) {
        // console.log('this.$refs.VueAliplayerV21',this.$refs.VueAliplayerV21)
        // console.log('this.$refs.VueAliplayerV22',this.$refs.VueAliplayerV22)
        if (this.$refs.VueAliplayerV21!==undefined) {
          this.$refs.VueAliplayerV21.pause();
          this.$refs.VueAliplayerV21.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
          this.$refs.VueAliplayerV22.pause();
          this.$refs.VueAliplayerV22.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
          this.$refs.VueAliplayerV23.pause();
          this.$refs.VueAliplayerV23.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
          this.$refs.VueAliplayerV24.pause();
          this.$refs.VueAliplayerV24.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
          this.$refs.VueAliplayerV25.pause();
          this.$refs.VueAliplayerV25.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
          this.$refs.VueAliplayerV26.pause();
          this.$refs.VueAliplayerV26.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
        }
      }
    },
    // 播放直播
    handleReady1(e){
      this.$refs.VueAliplayerV22.pause();
      this.$refs.VueAliplayerV22.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV23.pause();
      this.$refs.VueAliplayerV23.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV24.pause();
      this.$refs.VueAliplayerV24.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV25.pause();
      this.$refs.VueAliplayerV25.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV26.pause();
      this.$refs.VueAliplayerV26.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      if (this.playerv1 == 1) {
        console.log('playerv1',this.playerv1)
        return
      } else {
        this.getVideoIncr(1)
        this.playerv1 = 1
        console.log('playerv2',this.playerv1)
      }
    },
    handleReady2(e){
      this.$refs.VueAliplayerV21.pause();
      this.$refs.VueAliplayerV21.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV23.pause();
      this.$refs.VueAliplayerV23.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV24.pause();
      this.$refs.VueAliplayerV24.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV25.pause();
      this.$refs.VueAliplayerV25.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV26.pause();
      this.$refs.VueAliplayerV26.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      if (this.playerv2 == 1) {
        console.log('playerv21',this.playerv2)
        return
      } else {
        this.getVideoIncr(2)
        this.playerv2 = 1
        console.log('playerv22',this.playerv2)
      }
    },
    handleReady3(e){
      this.$refs.VueAliplayerV21.pause();
      this.$refs.VueAliplayerV21.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV22.pause();
      this.$refs.VueAliplayerV22.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV24.pause();
      this.$refs.VueAliplayerV24.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV25.pause();
      this.$refs.VueAliplayerV25.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV26.pause();
      this.$refs.VueAliplayerV26.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      if (this.playerv3 == 1) {
        console.log('playerv31',this.playerv3)
        return
      } else {
        this.getVideoIncr(3)
        this.playerv3 = 1
        console.log('playerv32',this.playerv3)
      }
    },
    handleReady4(e){
      this.$refs.VueAliplayerV21.pause();
      this.$refs.VueAliplayerV21.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV22.pause();
      this.$refs.VueAliplayerV22.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV23.pause();
      this.$refs.VueAliplayerV23.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV25.pause();
      this.$refs.VueAliplayerV25.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV26.pause();
      this.$refs.VueAliplayerV26.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      if (this.playerv4 == 1) {
        console.log('playerv41',this.playerv4)
        return
      } else {
        this.getVideoIncr(4)
        this.playerv4 = 1
        console.log('playerv42',this.playerv4)
      }
    },
    handleReady5(e){
      this.$refs.VueAliplayerV21.pause();
      this.$refs.VueAliplayerV21.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV22.pause();
      this.$refs.VueAliplayerV22.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV23.pause();
      this.$refs.VueAliplayerV23.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV24.pause();
      this.$refs.VueAliplayerV24.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV26.pause();
      this.$refs.VueAliplayerV26.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      if (this.playerv5 == 1) {
        console.log('playerv51',this.playerv5)
        return
      } else {
        this.getVideoIncr(5)
        this.playerv5 = 1
        console.log('playerv52',this.playerv5)
      }
    },
    handleReady6(e){
      this.$refs.VueAliplayerV21.pause();
      this.$refs.VueAliplayerV21.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV22.pause();
      this.$refs.VueAliplayerV22.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV23.pause();
      this.$refs.VueAliplayerV23.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV24.pause();
      this.$refs.VueAliplayerV24.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      this.$refs.VueAliplayerV25.pause();
      this.$refs.VueAliplayerV25.$el.getElementsByClassName("prism-big-play-btn")[0].style.display = "block";
      if (this.playerv6 == 1) {
        console.log('playerv61',this.playerv6)
        return
      } else {
        this.getVideoIncr(6)
        this.playerv6 = 1
        console.log('playerv62',this.playerv6)
      }
    },

    async getVideoIncr(id) {
      let data = new URLSearchParams();
      data.append('id',id)
      const res = await getVideoIncr(data)
      console.log(res)
      try {
        if (res.status === 200) {
          
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
  }
}
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
.prism-player {
  z-index: 1;
}
.veterinary {
  max-width: 768px;
  margin: 0 auto;
  .van-tab:nth-child(1) {
    border-right: 1px solid #eee;
  }
  .van-sticky {
    border: 1px solid #eeeeee;
  }
  .van-tab--active span {
    font-weight: bold;
    color: #127BE4;
  }
  .van-tabs__line {
    background-color: #127BE4;
    width: 60px;
  }
  .overview-box {
    .overview-img {
      font-size: 0;
      img {
        width: 100%;
      }
    }
  }

  .video-list {
    padding: 15px;
    .video-title {
      padding-left: 8px;
      border-left: 3px solid #127be4;
      font-size: 16px;
      font-weight: 600;
      font-family: PingFangSC, PingFangSC-Medium;
      text-align: left;
      color: #181818;
    }
    .video-heigh {
      margin-top: 30px;
    }
    .video-box {
      .video-content {
        padding-top: 10px;
        .prism-big-play-btn {
          left: 50% !important;
          bottom: 50% !important;
          margin-left: -30px;
          margin-bottom: -30px;
        }
        .prism-player .prism-big-play-btn {
          background: url(../assets/veterinaryclassimg/play.png) no-repeat;
          background-size: 100% 100%;
          width: 60px;
          height: 60px;
        }
        .prism-player .prism-big-play-btn .outter {
          border: 0;
        }
      }
      .video-text {
        padding: 10px 0;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: left;
        color: #181818;
      }
    }
  }
}
</style>

